import HotkeysManager from './HotkeysManager';

export default HotkeysManager;
